var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    "data-name": "Ebene 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 921.46 990.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #e6007e;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #fff;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calendar"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 109.13,
    width: 921.46,
    height: 881.32,
    rx: 70.07,
    ry: 70.07
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m55.03,371.77h811.4v526.81c0,22.08-17.92,40-40,40H103.35c-26.67,0-48.32-21.65-48.32-48.32V371.77h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 158.26,
    y: 432.45,
    width: 109.99,
    height: 109.99,
    rx: 20,
    ry: 20
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 323.24,
    y: 432.45,
    width: 109.99,
    height: 109.99,
    rx: 20,
    ry: 20
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 488.23,
    y: 432.45,
    width: 109.99,
    height: 109.99,
    rx: 20,
    ry: 20
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 653.21,
    y: 432.45,
    width: 109.99,
    height: 109.99,
    rx: 20,
    ry: 20
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 158.26,
    y: 597.43,
    width: 109.99,
    height: 109.99,
    rx: 20,
    ry: 20
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 488.23,
    y: 597.43,
    width: 109.99,
    height: 109.99,
    rx: 20,
    ry: 20
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 653.21,
    y: 597.43,
    width: 109.99,
    height: 109.99,
    rx: 20,
    ry: 20
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 158.26,
    y: 767.92,
    width: 109.99,
    height: 109.99,
    rx: 20,
    ry: 20
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 323.24,
    y: 767.92,
    width: 109.99,
    height: 109.99,
    rx: 20,
    ry: 20
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 488.23,
    y: 767.92,
    width: 109.99,
    height: 109.99,
    rx: 20,
    ry: 20
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 323.24,
    y: 596.76,
    width: 109.99,
    height: 109.99,
    rx: 20,
    ry: 20
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 221.21,
    cy: 199.32,
    r: 55.86
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 185.11,
    width: 72.2,
    height: 235.81,
    rx: 36.1,
    ry: 36.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 683.51,
    cy: 199.32,
    r: 55.86
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 647.41,
    width: 72.2,
    height: 235.81,
    rx: 36.1,
    ry: 36.1
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.0e1dd1fb0f4a421d5510a5d485bafe35.svg";
export { ForwardRef as ReactComponent };